module.exports = __webpack_public_path__ + "kudos_46.svg?389c8433cebde6cc4f4ddde6ddeafaad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_46.svg
// module id = 146
// module chunks = 0